/**
 * @author Kelnik
 *
 * ToggleHeight - Аккордион по аттрибутам
 */

import Utils from 'common/scripts/utils';

class ToggleHeight {
    constructor(options) {
        this.target = options.element;
    }

    init() {
        if (!this.target) {
            return;
        }

        this._initElements();
        this._bindEvents();
    }

    _initElements() {
        this.content = document.getElementById(this.target.dataset.toggleContent);
    }

    _bindEvents() {
        this.target.addEventListener('click', this._afterTargetClick.bind(this));

        window.addEventListener('resize', Utils.debounce(this._checkHeight.bind(this), 100));
    }

    _afterTargetClick(event) {
        event.preventDefault();

        if (this._isActive()) {
            this._deActive();
            this._hide();
        } else {
            this._setActive();
            this._show();
        }
    }

    _isActive() {
        return Boolean(this.target.classList.contains('is-active'));
    }

    _setActive() {
        this.target.classList.add('is-active');
    }

    _deActive() {
        this.target.classList.remove('is-active');
    }

    _checkHeight() {
        if (window.innerWidth >= this.target.dataset.maxViewport) {
            this._removeContentStyle();

            return;
        }

        if (this._isActive()) {
            this._show();
        } else {
            this._hide();
        }
    }

    _hide() {
        const height = this.target.dataset.height || 0;

        this.content.style.maxHeight = `${height}px`;
    }

    _show() {
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }

    _removeContentStyle() {
        if (this.content.hasAttribute('style')) {
            this.content.removeAttribute('style');
        }
    }
}

export default ToggleHeight;
